module.exports = __webpack_public_path__ + "img/image52.f964e6c2.webp";